import { DefaultTheme, NavigationContainer } from '@react-navigation/native';
import { Box, NativeBaseProvider } from 'native-base';
import React from 'react';
import { Provider } from 'react-redux';
import { Platform } from 'react-native';

import TopLevel from './screens/TopLevel';
import store from './store';

var baseURL = '';
if (Platform.OS == 'web') baseURL = '/apps/monnaide';

const linking = {
  prefixes: [],
  config: {
    screens: {
      Home: `${baseURL}`,
      Payments: `${baseURL}/paiements`,
    },
  },
};

const theme = {
  ...DefaultTheme,
  colors: {
    ...DefaultTheme.colors,
    background: '#fff',
  },
};

function App() {
  return (
    <Provider store={store}>
      <NativeBaseProvider>
        <NavigationContainer linking={linking} theme={theme}>
          <Box safeArea height="100%" width="100%">
            <TopLevel />
          </Box>
        </NavigationContainer>
      </NativeBaseProvider>
    </Provider>
  );
}

export default App;
